import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://pzbtscdnhhmznlomdqwz.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB6YnRzY2RuaGhtem5sb21kcXd6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg2OTExODEsImV4cCI6MjA1NDI2NzE4MX0.wj2VORXxT3vKI6oJj08kfTKfKKZjz9xKsyx6lArN5pI';

// Add validation
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase credentials:', {
    url: !!supabaseUrl,
    key: !!supabaseAnonKey
  });
  throw new Error('Missing Supabase credentials');
}

const supabaseClient = createClient(supabaseUrl, supabaseAnonKey);

// Test connection
supabaseClient.from('tickets').select('count')
  .then(({ data, error }) => {
    if (error) {
      console.error('Supabase initialization error:', error);
    } else {
      console.log('Supabase initialized successfully');
    }
  });

export default supabaseClient;

// Log to verify the values (remove in production)
console.log('Supabase URL:', supabaseUrl);
console.log('Supabase Key exists:', !!supabaseAnonKey);
